import axios from "axios";
import { getToken } from "../auth/authService";

function authHeaders() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const searchPayloads = (params) =>
  axios
    .get("/dashboard/payloads", { params, headers: authHeaders() })
    .then((r) => r.data);

export const getPayloadXml = (docnum, payloadType, materialNumber, supplierNumber) =>
  axios
    .get("/dashboard/payloads/xml", {
      params: { docnum, payloadType, materialNumber, supplierNumber },
      headers: authHeaders(),
    })
    .then((r) => r.data);
